/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconRotate = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M7.254 3.04c4.723-2.384 10.498-.53 12.895 4.141L23 5.741l-1.873 5.68-5.73-1.84 2.85-1.44c-1.866-3.638-6.35-5.078-10.029-3.22-3.678 1.856-5.143 6.3-3.277 9.938 1.867 3.638 6.351 5.078 10.03 3.22a7.492 7.492 0 0 0 3.231-3.17l2.045.672a9.588 9.588 0 0 1-4.312 4.378c-4.724 2.386-10.498.531-12.895-4.14C.643 11.147 2.53 5.425 7.254 3.04Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconRotate.displayName = 'IconRotate';
export default IconRotate;
